var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"copritutto\" ng-show=\"bsCtrl.bs.attivo\">\n<div style=\"float:right; color: white; padding: 20px;\">Caricamento in corso</div>\n</div>\n";
var id1="screensaver.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;